import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IVenueOpeningTimesRequest } from './types';

export const createVenueOpeningTimes = (venueId: string, payload: IVenueOpeningTimesRequest): Promise<any> => {
  return fetch(`${API_URL}/venues/${venueId}/schedules`, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
